import { render, staticRenderFns } from "./PaymentMethodsList.vue?vue&type=template&id=d482cabc&scoped=true"
import script from "./PaymentMethodsList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsList.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsList.vue?vue&type=style&index=0&id=d482cabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d482cabc",
  null
  
)

export default component.exports